<template>
  <div>
      <button class="btn btn-sm btn-danger item-delete" @click="$emit('remove', index)" ><i class="ti-trash"></i> </button>

      <div class="post-content-video">
          <iframe :src="data.value"/>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      default: null,
    },
    data: {
      default: null,
    },
  },
  methods: {

  }
};
</script>
